import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import {
	MatFormField,
	MatLabel,
	MatInput,
	MatError,
} from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
	selector: 'formly-postal-code-input',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<mat-form-field appearance="outline" style="width: 100%">
			<mat-label>{{ props.label }}</mat-label>
			<input
				matInput
				[formControl]="formControl"
				[formlyAttributes]="field"
				[required]="props.required"
				mask="S0S 0S0"
				[placeholder]="props.placeholder || 'S0S 0S0'"
			/>
			<mat-error *ngIf="formControl.invalid && formControl.touched">
				<formly-validation-message [field]="field"></formly-validation-message>
			</mat-error>
		</mat-form-field>
	`,
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		NgxMaskDirective,
		ReactiveFormsModule,
		FormlyModule,
		NgIf,
		MatError,
	],
})
export class PostalCodeInputType extends FieldType<FieldTypeConfig> {}
